import { DateTime } from 'luxon';

export function formatDate(value: string | Date | number, format = 'dd/MM/yyyy'): string {
  // Handle empty strings early to avoid unnecessary DateTime parsing
  if (typeof value === 'string' && value === '') return '';

  let dt: DateTime;

  if (value instanceof Date) {
    dt = DateTime.fromJSDate(value);
  } else if (typeof value === 'number') {
    dt = DateTime.fromMillis(value);
  } else {
    dt = DateTime.fromISO(value);
  }

  return dt.isValid ? dt.toFormat(format) : '';
}
